import { useTranslation } from 'react-i18next'

import { DATE_WEEKDAY_SHORT_FORMAT } from '../../../../constants/date'
import { useDateLocale } from '../../../../hooks'
import { formatCalendarGridDay } from '../../CalendarGrid.utils'
import { CalendarGridCardField } from '../../CalendarGridCardField'

function CalendarGridDayPopoverDate({ day }) {
  const { t } = useTranslation()

  const locale = useDateLocale()

  return (
    <CalendarGridCardField
      label={t('Calendar.DateLabelKey')}
      value={formatCalendarGridDay({
        dateFormat: DATE_WEEKDAY_SHORT_FORMAT,
        day,
        locale,
      })}
    />
  )
}

export default CalendarGridDayPopoverDate
